// Hiusextra: suodattimien lisäkäytös kokoelma- ja hakusivuilla.
(function () {
  // 1) Hintasuodattimen liukusäädin (snippets/price-filter.liquid). Vetäessä säädin päivittää hintakentät
  // ja täytön; vapautettaessa natiivi change kuplii price-facet-componentille, joka päivittää suodatuksen
  // samalla tavalla kuin kenttään kirjoitettaessa. Ääripäässä kenttä tyhjennetään (ei rajaa).
  function sync(range) {
    var wrap = range.closest('.hx-price-range');
    var facet = range.closest('price-facet-component');
    if (!wrap || !facet) return;

    var min = wrap.querySelector('[data-hx-range="min"]');
    var max = wrap.querySelector('[data-hx-range="max"]');
    var top = Number(max.max) || 1;
    var lo = Number(min.value);
    var hi = Number(max.value);

    if (lo > hi) {
      if (range === min) min.value = String((lo = hi));
      else max.value = String((hi = lo));
    }

    // Kun alaraja on oikeassa reunassa, sen kahva nostetaan päälle, jotta sitä voi vetää takaisin.
    min.style.zIndex = lo >= top / 2 ? '3' : '';
    wrap.style.setProperty('--hx-lo', String(lo / top));
    wrap.style.setProperty('--hx-hi', String(hi / top));

    var inputs = facet.querySelectorAll('.price-facet__input');
    if (inputs.length < 2) return;
    inputs[0].value = lo > 0 ? String(lo) : '';
    inputs[1].value = hi < top ? String(hi) : '';
  }

  document.addEventListener('input', function (event) {
    var target = event.target;
    if (target instanceof HTMLInputElement && target.classList.contains('hx-price-range__input')) sync(target);
  });

  // 2) Itse avattu tai suljettu suodatin pysyy sellaisena, kun teema päivittää suodatinosion valinnan jälkeen
  // (palvelimen HTML avaisi vain oletuksena auki olevat, ks. snippets/list-filter.liquid).
  var chosen = new Map();

  function key(details) {
    var accordion = details.closest('accordion-custom');
    if (!accordion) return '';
    return (details.closest('dialog') ? 'd:' : 's:') + (accordion.getAttribute('data-filter-param-name') || 'price');
  }

  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target instanceof Element ? event.target.closest('summary.facets__summary') : null;
      var details = summary && summary.parentElement;
      if (!(details instanceof HTMLDetailsElement)) return;
      // Kaappausvaiheessa details on vielä vanhassa tilassa; klikkaus kääntää sen.
      var k = key(details);
      if (k) chosen.set(k, !details.open);
    },
    true
  );

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      var details = record.target;
      if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('facets__panel')) return;
      var k = key(details);
      if (!chosen.has(k)) return;
      if (chosen.get(k)) {
        if (!details.open) details.open = true;
        return;
      }
      // Itse suljettu pysyy kiinni, paitsi jos siinä on valinta.
      var active = Array.prototype.some.call(details.querySelectorAll('input'), function (input) {
        return input.type === 'checkbox' || input.type === 'radio' ? input.checked : input.type === 'text' && input.value !== '';
      });
      if (details.open && !active) details.open = false;
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();
